import React from "react";
import { Link } from "react-router-dom";
import entrecor_logo_blanco from "../assets/entrecor_logo_blanco.png";
import facebook_icon_white from "../assets/facebook_icon_white.png";
import instagram_icon_white from "../assets/instagram_icon_white.png";
import phone_icon_white from "../assets/phone_icon_white.png";
import email_icon_white from "../assets/email_icon_white.png";

function Footer() {
  return (
    <footer id="footer" className="bg-[#3A3A3C]">
      <div className="mx-auto w-full max-w-screen-2xl px-5 py-8 sm:p-8 flex flex-col lg:flex-row justify-around items-start gap-8">
      <div className="flex flex-col w-full lg:w-52" data-scroll-reveal>
        <img src={entrecor_logo_blanco} alt="logo" className="mb-4 w-52 max-w-full" />
        <p className="text-white text-sm leading-6 font-noto font-thin">
        Al servicio de nuestros clientes
        La organización de los procesos, la intervención de calidad y el aporte de diseño y desarrollo hacen posible nuestro objetivo: entregar un producto a precios competitivos y a tiempo.
        </p>
      </div>
      <ul className="font-noto font-light flex flex-col gap-2 w-full lg:w-auto" data-scroll-reveal data-scroll-reveal-delay="80ms">
        <li className="p-2 md:p-0">
          <Link to="/#quienes-somos" className="text-white hover:underline">
            Quienes Somos
          </Link>
        </li>
        <li className="p-2 md:p-0">
          <Link to="/#productos" className="text-white hover:underline">
            Productos
          </Link>
        </li>
        <li className="p-2 md:p-0">
          <Link to="/sectores/proceso_productivo" className="text-white hover:underline">
            Sectores
          </Link>
        </li>
        <li className="p-2 md:p-0">
          <Link to="/#contacto" className="text-white hover:underline">
            Contacto
          </Link>
        </li>
        <li className="p-2 md:p-0">
          <Link to="/#ubicacion" className="text-white hover:underline">
            Ubicación
          </Link>
        </li>
      </ul>
      <div className="flex flex-col gap-4 w-full lg:w-auto" data-scroll-reveal data-scroll-reveal-delay="140ms">
        <h3 className="text-white font-gotham font-medium text-xl">
          CONTACTO
        </h3>
        <div className="flex flex-row items-center gap-4">
          <div className="w-3.5">
            <img src={phone_icon_white} alt="phone" className="w-full" />
          </div>
          <a href="tel:+543442407473" className="text-white text-sm hover:underline">Tel. +54 3442 407473</a>
        </div>
        <div className="flex flex-row items-center gap-4">
          <div className="w-3.5">
            <img src={email_icon_white} alt="email" className="w-full" />
          </div>
          <a href="mailto:info@entrecor.com.ar" className="text-white text-sm hover:underline">info@entrecor.com.ar</a>
        </div>
        <div className="flex flex-row gap-4">
          <a href="https://www.facebook.com/profile.php?id=61558971364968" target="_blank" rel="noreferrer">
            <img src={facebook_icon_white} alt="facebook" className="w-6" />
          </a>
          <a href="https://www.instagram.com/entrecor.sa/" target="_blank" rel="noreferrer">
            <img src={instagram_icon_white} alt="instagram" className="w-6" />
          </a>
        </div>
      </div>
      </div>
    </footer>
  );
}

export default Footer;
